import { z } from 'zod';
import { MinorUnits } from './money';

/**
 * A settled round, as the platform sees it.
 *
 * `totalWin` is the only field it reads: minor units, `0` or the amount to
 * credit. Everything else is the game's own record of what happened, stored
 * as-is for history and handed to the client to animate. The platform does
 * not know what a "crashPoint" or a "dealerTotal" is, and does not need to.
 */
export const GameRoundResult = z.object({ totalWin: MinorUnits }).catchall(z.unknown());
export type GameRoundResult = z.infer<typeof GameRoundResult>;
